import isEqual from 'lodash/fp/isEqual';
import { useEffect, useRef, useState } from 'react';

export default (props: any) => {
  const prevPropsRef = useRef(props);
  const [isPropsChange, setIsPropsChange] = useState({});

  useEffect(() => {
    if (isEqual(props, prevPropsRef.current)) return;

    prevPropsRef.current = props;
    setIsPropsChange({});
  });

  return isPropsChange;
};
